import React from 'react';
import FeaturedCallOut from './FeaturedCallOut';
import {HomeRouteContext} from '../../utils/context';
import {removeFalsyValuesInArray} from '../../utils/utils';

const FeaturedCallOutsSection = ({id, callOuts}) => {
    const filteredCallOuts = removeFalsyValuesInArray(callOuts);
    if (!filteredCallOuts.length) {
        return null;
    }

    const renderedCallOuts = filteredCallOuts.map((callOut, idx) => {
        const {parent, path, __typename} = callOut;
        const isArticle = __typename === 'Article';

        return (
            <HomeRouteContext.Consumer key={`callout-${idx}`}>
                {(homeRoute) => (
                    <FeaturedCallOut
                        {...callOut}
                        subtitle={isArticle && parent && parent.name}
                        link={`${homeRoute}${path}`}
                        withButton={!isArticle}
                    />
                )}
            </HomeRouteContext.Consumer>
        );
    });

    return (
        <section id={id} className="FeaturedCallOutsSection hub-section">
            {renderedCallOuts}
        </section>
    );
};

export default FeaturedCallOutsSection;
